/*
 * Reading numbers out of text the way people write them in tables
 * ("1,234", "$12.50", "45%"). Kept apart so the chat table can sort without
 * loading the spreadsheet readers.
 */

const PLAIN_NUMBER = /^[+-]?(\d+(\.\d+)?|\.\d+)([eE][+-]?\d+)?$/;
const GROUPED_NUMBER = /^[+-]?\d{1,3}(,\d{3})+(\.\d+)?$/;

const COMMA_DECIMAL_GROUPED = /^[+-]?\d{1,3}(\.\d{3})+(,\d+)?$/;
const COMMA_DECIMAL = /^[+-]?\d+,\d+$/;

/**
 * A number for sorting, or null when the text isn't one (or has leading
 * zeros). With `decimalComma` (semicolon CSVs from Europe), "1.200,50" is
 * 1200.5.
 */
export function numericValue(
  raw: string,
  options: { decimalComma?: boolean } = {},
): number | null {
  const value = raw.trim();
  if (!value) return null;
  // Leading zeros (IDs, ZIP codes) stay text.
  if (/^[+-]?0\d/.test(value)) return null;
  let digits = value;
  let scale = 1;
  if (digits.endsWith('%')) {
    digits = digits.slice(0, -1);
    scale = 0.01;
  }
  digits = digits.replace(/^([+-]?)[$€£¥]\s?/, '$1').replace(/\s?€$/, '');
  if (options.decimalComma) {
    if (COMMA_DECIMAL_GROUPED.test(digits) || COMMA_DECIMAL.test(digits)) {
      digits = digits.replace(/\./g, '').replace(',', '.');
    } else if (digits.includes(',')) {
      return null;
    }
  } else if (GROUPED_NUMBER.test(digits)) {
    digits = digits.replace(/,/g, '');
  }
  if (!PLAIN_NUMBER.test(digits)) return null;
  const n = Number(digits) * scale;
  return Number.isFinite(n) ? n : null;
}
